import { StepProps } from './Step';
import React from 'react';
import { FlexBox } from '@ardoq/layout';

/**
 * @param child: React.ReactElement<StepProps> is a child of type Step, we will add a number to it
 * if it doesn't have an icon or custom number
 * @returns wrapped child with number if it doesn't have an icon or custom number
 */

function AddStepNumber({
  child,
  index = 0,
}: {
  child: React.ReactElement<StepProps>;
  index?: number;
}) {
  return !child.props.stepNumber
    ? React.cloneElement(child, { stepNumber: index + 1 })
    : child;
}

type HorizontalStepperProps = {
  children: React.ReactElement<StepProps> | React.ReactElement<StepProps>[];
};

export function HorizontalStepper({ children }: HorizontalStepperProps) {
  return (
    <FlexBox>
      {Array.isArray(children) ? (
        children.map((child, index) => (
          <AddStepNumber key={index} child={child} index={index} />
        ))
      ) : (
        <AddStepNumber child={children} />
      )}
    </FlexBox>
  );
}
